export default __webpack_public_path__ + "static/media/Diagram.fdcc56d3.svg";